import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable} from "rxjs";
import { APP_CONFIG, AppConfig } from "src/app/shared/services/config-initialization.service";
import { CreateRefreshmentTimeForms, RefreshmentTimeSection } from "./refreshmentTimeForm";

const apiURLs = {
    getUserInfo: '/documents/kycRefreshment',
    getKycStatus: '/documents/kyc/statusInfo'
}

@Injectable({
    providedIn: 'root'
  })
  export class RefreshmentTimeService {
  private kycStatus: BehaviorSubject<any> = new BehaviorSubject(null);
  
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private readonly http: HttpClient
  ) { }

  getUserInfo(): Observable<any> {
    return this.http.get(this.config.restApiUrl + apiURLs.getUserInfo).pipe(map(
      (res: RefreshmentTimeSection[]) => {
        //console.log('userData from service:', res);
        const forms = new CreateRefreshmentTimeForms(res);
        return forms.createForms();
      }
    ));
  }

  getKycStatus(): Observable<any> {
    return this.http.get(this.config.restApiUrl + apiURLs.getKycStatus).pipe(
      map(res => {
        this.kycStatus.next(res);
        return res;
      })
    );;
  }

  getKycStatusValue(): any {
    return this.kycStatus.asObservable();
  }
}